import { Translation } from '@/app/translations/Translation'

export const DEVICE_ORDER_STATUS_ID = {
  AT_VENDOR: -1,
  OPEN: -2,
  ALL: -3,
  NEW: 0,
  DENIED: 1,
  PROCESSING: 2,
  PROCESSED: 3,
  DELIVERED: 4,
  IN_ECOM: 5,
}

export const STATUS_FILTER_OPTIONS = [
  { value: DEVICE_ORDER_STATUS_ID.ALL, label: <Translation id="device_order_status/ALL" /> },
  { value: DEVICE_ORDER_STATUS_ID.NEW, label: <Translation id="device_order_status/NEW" /> },
  {
    value: DEVICE_ORDER_STATUS_ID.AT_VENDOR,
    label: <Translation id="device_order_status/AT_VENDOR" />,
  },
  {
    value: DEVICE_ORDER_STATUS_ID.DELIVERED,
    label: <Translation id="device_order_status/DELIVERED" />,
  },
  {
    value: DEVICE_ORDER_STATUS_ID.DENIED,
    label: <Translation id="device_order_status/DENIED" />,
  },
]

export const DEVICE_ORDER_STATUS_NAMES = [
  'NEW',
  'DENIED',
  'PROCESSING',
  'PROCESSING',
  'DELIVERED',
  'PROCESSING',
]
